
export default {
    namespaced: true,
    state: () => ({
      isDarkMode : false,
    }),
    mutations: {
        setIsDarkMode(state,payload){
            state.isDarkMode = payload;
            localStorage.setItem("isDarkMode",payload);
        },
        initialIsDarkMode(state){
            const savedIsDark = JSON.parse(localStorage.getItem("isDarkMode") || "false");
            if(savedIsDark){
                state.isDarkMode = true;
            }
        }
    },
    actions: {},
    getters : {
        isDarkMode: (state) => state.isDarkMode,
    },
  };
  